import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import CreationDialog from "../../../../components/dialogs/CreationDialog.js";

export default function CreateHostDialog({
  locales,
  onInput,
  onClose,
  onConfirm,
  serial,
  show,
}) {
  return (
    <CreationDialog
      actionButtonText={locales["host.create.register"]}
      bodyPrimary={locales["host.create.body"]}
      icon={PersonAddAltIcon}
      inputId="create-host-name"
      inputLabel={locales["host.create.label"]}
      inputValue={serial}
      locales={locales}
      onActionClick={onConfirm}
      onInput={onInput}
      onClose={onClose}
      show={show}
    />
  );
}
